'use strict';

import Loading from '~/components/Loading';
import HighlightedText from '~/components/HighlightedText';
import TimerWidget from '~/components/TimerWidget';

export default function AuthCodeConfirm({ phone, code, status, timeout, isFetching, onCodeChange, onResend, codePlaceholderKey }) {
    return (
        <div>
            <div className="reg-modal__title">
                {__('[Auth][Confirm] Title')}
            </div>
            <div className="reg-modal__text">
                <HighlightedText text={__('[Auth][Confirm] Sent code to {phone}', { '{phone}': phone })} highlights={[{ word: phone, style: 'bold' }]} multiline />
            </div>
            <div className="reg-modal__row">
                <div className="reg-input reg-input__code">
                    {status === 'error_wrong' && <div className="reg-input__error">
                        {__('[Auth][Confirm] Invalid code')}
                    </div>}
                    {status === 'error_attempts' && <div className="reg-input__error">
                        {__('[Auth][Confirm] Attempts over')}
                    </div>}
                    <input
                        id="authCodeInput"
                        value={code}
                        placeholder={codePlaceholderKey ? __(codePlaceholderKey) : undefined}
                        type="text"
                        maxLength="4"
                        onChange={onCodeChange}
                    />
                </div>
            </div>
            {timeout > 0 && <div className="reg-modal__timer">
                {__('[Auth][Confirm] New code in {time}', { '{time}': '' })} <TimerWidget seconds={timeout} />
            </div>}
            {timeout === 0 && <div className="reg-modal__timer">
                <a onClick={onResend}>{__('[Auth][Confirm] Get new code')}</a>
            </div>}
            <Loading active={isFetching} />
        </div>
    );
}
